import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NavbarComponent } from './navbar.component';
import { InputSwitchModule } from 'primeng/inputswitch';
import { FormsModule } from '@angular/forms';
import { NavbarV2Component } from './navbar-v2/navbar-v2.component';
import { RelativeTimePipe } from '../relative-time.pipe';
import { FeatureFlagDirective } from '../directives/feature-flag.directive';

@NgModule({
	imports: [RouterModule, CommonModule, FormsModule, InputSwitchModule, RelativeTimePipe, FeatureFlagDirective],
	declarations: [NavbarComponent, NavbarV2Component],
	exports: [NavbarComponent, NavbarV2Component],
})
export class NavbarModule {}
